function focusEventListener() {
	return require('./eventListenerCore')('focus');
}

module.exports = focusEventListener;